const PROMETHEUS_URL = 'https://prometheus.u-like-it.de';
const PROMETHEUS_USER = 'admin';
const PROMETHEUS_PASS = 'Tea4me2N8';

const headers = {
  Authorization: 'Basic ' + btoa(`${PROMETHEUS_USER}:${PROMETHEUS_PASS}`),
};

export async function queryPrometheus(query: string): Promise<unknown> {
  const res = await fetch(
    `${PROMETHEUS_URL}/api/v1/query?query=${encodeURIComponent(query)}`,
    { headers },
  );
  if (!res.ok) throw new Error(`Prometheus error: ${res.status}`);
  const data = await res.json();
  return data.data?.result ?? [];
}

export async function queryAlerts(): Promise<unknown[]> {
  const res = await fetch(`${PROMETHEUS_URL}/api/v1/alerts`, { headers });
  if (!res.ok) throw new Error(`Prometheus error: ${res.status}`);
  const data = await res.json();
  return data.data?.alerts ?? [];
}
